module.exports = __webpack_public_path__ + "img/curriculum_des_2.40886f9f.jpg";